// Header logic has been merged into Navbar component
const Header = () => null;
export default Header;
